import { eTipoPermissao } from '@/enums/ePermissoes';

export default [
  {
    description: 'Relatórios de Transporte Aluno',
    path: '/transporte/trarelatoriotransportealuno',
    name: 'trarelatoriotransportealuno',
    component: () => import('@/views/transporte/trarelatoriotransportealuno/Configuracao.vue'),
    meta: {
      permissions: [eTipoPermissao.RELATORIOALUNOSTRANSPORTENOVO_MENU_1100100699],
    },
    goesToMenu: true,
  },
];
